// ----------------------------------------
// MAIN CONFIGURATION FILE
// ----------------------------------------
// SERVER_URL Configuration:
// - Development: Backend runs on port 5000, frontend on 3000
//   Use: http://localhost:5000 
//
// - Production (Docker): Backend runs on api subdomain
//   For EC2 deployment: https://api.samarth-ar10.com (API subdomain)
//
// - For local Docker testing: http://localhost:5000 (direct connection to backend)

// BACKEND API URL
const SERVER_URL = "https://api.samarth-ar10.com";  // API subdomain

const config = {
    // API endpoints
    API_URL: SERVER_URL,
    CHAT_ENDPOINT: `${SERVER_URL}/api/chat`,
    TEST_PROMPT_ENDPOINT: `${SERVER_URL}/api/test_prompt`,

    // Other configurations
    DEFAULT_THEME: "light",
    MESSAGE_LIMIT: 50,

    // Frontend URLs (mainly for reference)
    FRONTEND_DEV_URL: "https://samarth-ar10.com:3000",
    FRONTEND_PROD_URL: "https://samarth-ar10.com"
};

export default config; 